module.exports = "../../app/cells/pages/bifrost/study_guides/search_bar_cell.rb";